export { default } from './BancoDoAutoModalDisclaimer';
